import { restaurant } from "../data/menu";

const HERO_BG =
  "https://images.unsplash.com/photo-1579751626657-72bc17010498?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHx3b29kJTIwZmlyZSUyMHBpenphJTIwb3ZlbiUyMHJ1c3RpY3xlbnwwfHx8fDE3Nzg5NzEwMjZ8MA&ixlib=rb-4.1.0&q=85";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[92vh] flex items-end overflow-hidden"
    >
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${HERO_BG})` }}
        aria-hidden="true"
      />
      <div
        className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/55 to-black/35"
        aria-hidden="true"
      />

      {/* Décor: Italian flag accent strip */}
      <div className="absolute top-0 inset-x-0 h-1.5 flex">
        <div className="flex-1 bg-[#2d4a22]"></div>
        <div className="flex-1 bg-white"></div>
        <div className="flex-1 bg-[#c23b22]"></div>
      </div>

      <div className="relative w-full max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 pb-20 lg:pb-32 pt-32">
        <div className="max-w-3xl">
          <p
            className="pv-fade-up inline-flex items-center gap-3 text-white/90 text-xs sm:text-sm tracking-[0.32em] uppercase mb-7"
            data-testid="hero-eyebrow"
          >
            <span className="w-10 h-px bg-[#c23b22]" />
            Pizzeria artisanale · depuis le four
          </p>
          <h1
            className="pv-fade-up delay-1 font-serif text-white text-5xl sm:text-6xl lg:text-8xl leading-[0.95] tracking-tight"
            data-testid="hero-title"
          >
            La <em className="text-[#f6c177]">vraie</em> pizza
            <br />
            <span className="italic font-light">italienne à Mamers.</span>
          </h1>
          <p
            className="pv-fade-up delay-2 mt-8 text-white/85 text-lg sm:text-xl max-w-xl leading-relaxed"
            data-testid="hero-description"
          >
            Pâte pétrie chaque jour par notre Pizzaïolo, préparée et cuite à la
            commande. {restaurant.tagline}.
          </p>

          <div className="pv-fade-up delay-3 mt-10 flex flex-wrap items-center gap-4">
            <a
              href={`tel:${restaurant.phoneRaw}`}
              data-testid="hero-phone-cta"
              className="group inline-flex items-center gap-4 bg-[#c23b22] hover:bg-[#a12e1a] text-white pl-7 pr-3 py-3 rounded-full text-base sm:text-lg font-semibold shadow-2xl transition-colors"
            >
              <span className="inline-flex items-center gap-3">
                <i className="fa-solid fa-phone" aria-hidden="true"></i>
                <span>Commander : {restaurant.phone}</span>
              </span>
              <span className="w-11 h-11 rounded-full bg-white text-[#c23b22] inline-flex items-center justify-center group-hover:scale-110 transition-transform">
                <i className="fa-solid fa-arrow-right" aria-hidden="true"></i>
              </span>
            </a>
            <a
              href="#menu"
              data-testid="hero-menu-link"
              className="inline-flex items-center gap-2 text-white border border-white/40 hover:border-white px-6 py-3 rounded-full text-sm uppercase tracking-[0.2em] backdrop-blur-sm transition-colors"
            >
              Voir le menu
              <i className="fa-solid fa-arrow-down" aria-hidden="true"></i>
            </a>
          </div>

          <div className="pv-fade-up delay-3 mt-14 flex flex-wrap gap-x-10 gap-y-4 text-white/80 text-sm">
            <span className="inline-flex items-center gap-2">
              <i className="fa-solid fa-location-dot text-[#f6c177]" />
              {restaurant.address}, {restaurant.city}
            </span>
            <span className="inline-flex items-center gap-2">
              <i className="fa-regular fa-clock text-[#f6c177]" />À partir de
              18h00 — fermé le mardi
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
